import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Employment', to: '/employment/ifys-recruitment' },
  { label: 'Current Vacancies' },
];

const CurrentVacanciesPage = () => {
  return (
    <PageLayout activeLink="employment">
      <PageHero
        title="Current Vacancies"
        backgroundImage="/images/thumb2.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="bg-ifys-light-gray border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 py-12 sm:py-16 md:py-20">
          <Link
            to="/employment/ifys-recruitment"
            className="group inline-flex items-center gap-2 mb-8 text-sm sm:text-base font-semibold text-ifys-blue hover:text-ifys-dark-blue transition-colors duration-200 ease-smooth focus:outline-none focus:ring-2 focus:ring-ifys-blue focus:ring-offset-2 focus:ring-offset-ifys-light-gray rounded-lg py-2 -mx-1 px-1"
          >
            <svg
              className="w-5 h-5 shrink-0 transition-transform duration-200 ease-smooth group-hover:-translate-x-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to IFYS Careers
          </Link>

          <div className="max-w-4xl mx-auto">
            <p className="mb-6 text-sm sm:text-base text-gray-700 leading-relaxed">
              Would you like to share a role with someone external? Send them this page:{' '}
              <Link
                to="/employment/current-vacancies"
                className="text-ifys-blue font-semibold hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ifys-blue focus-visible:ring-offset-2 rounded"
              >
                www.ifys.com.au/employment/current-vacancies
              </Link>
            </p>

            <div className="rounded-2xl overflow-hidden bg-white shadow-sm border border-gray-200 p-2 sm:p-3">
              <iframe
                src="https://ifys.elmotalent.com.au/careers/default/jobs?layout=iframe"
                className="w-full h-[1000px] border-0 block rounded-xl"
                title="IFYS Job Listings"
              />
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default CurrentVacanciesPage;
